import { Link as RouterLink, useLocation, useMatches, useNavigate } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';

import { ArrowLeftOutline, ChevronRightOutline } from '@aslanpay/portal-common-lib';

import { FromCrumb, MatchDataType, MatchHandleProps } from './types';

function CustomBreadcrumb() {
  const navigate = useNavigate();

  const showBackButton = useBreakpointValue({ base: true, sm: false });

  const matches = useMatches();

  const location = useLocation();

  const fromCrumbs = (location.state as { fromCrumbs?: FromCrumb[] } | null)?.fromCrumbs;

  const matchedCrumbs = matches
    .filter((match) => Boolean((match.handle as MatchHandleProps)?.crumb))
    .map((match, index) => {
      const name = (match.handle as MatchHandleProps).crumb(match.data as MatchDataType);

      return {
        index,
        path: match.pathname,
        params: match.params,
        name,
        disabled: match.pathname === location.pathname,
      };
    });

  const crumbs =
    fromCrumbs && matchedCrumbs.length > 0
      ? [
          ...fromCrumbs.map((c, i) => ({
            index: i,
            path: c.path,
            params: {},
            name: c.name,
            disabled: false,
          })),
          { ...matchedCrumbs[matchedCrumbs.length - 1], index: fromCrumbs.length },
        ]
      : matchedCrumbs;

  if (showBackButton && crumbs.length > 1) {
    return (
      <Button
        alignSelf="flex-start"
        size="sm"
        variant="link"
        leftIcon={<ArrowLeftOutline boxSize="20px" />}
        onClick={() => navigate(-1)}
      >
        Back
      </Button>
    );
  }

  return (
    <Breadcrumb
      display="flex"
      width="full"
      spacing="5px"
      separator={<ChevronRightOutline color="brand.darkGray" boxSize="10px" />}
      textStyle="smallMedium"
      color="brand.purple"
      overflow="hidden"
      listProps={{ overflow: 'hidden' }}
    >
      {crumbs.map((crumb, index) => {
        return (
          <BreadcrumbItem key={crumb.index} overflow="hidden">
            {!crumb.disabled && index !== crumbs.length - 1 ? (
              <BreadcrumbLink
                as={RouterLink}
                to={crumb.path}
                py="5px"
                px="10px"
                borderRadius="5px"
                isTruncated
                _hover={{ bgColor: 'brand.lightGray2' }}
              >
                {crumb.name}
              </BreadcrumbLink>
            ) : (
              <Text py="5px" px="10px" textStyle="smallMedium" color="brand.darkGray" isTruncated>
                {crumb.name}
              </Text>
            )}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
}

export default CustomBreadcrumb;
